import { render, staticRenderFns } from "./ModelLogs.vue?vue&type=template&id=322979a4&"
import script from "./ModelLogs.vue?vue&type=script&lang=js&"
export * from "./ModelLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports